import React from 'react';
import TextField from '@material-ui/core/TextField';
import { Grid, Button } from 'semantic-ui-react'
import Server from '../../../functions/server'
import $ from "jquery";
import Loading from '../../loading';
import CircularProgress from '@material-ui/core/CircularProgress';

class AddPartAlias extends React.Component {

  state = {
    load: false, message: '',
    part_alias: this.props.part_alias,
    mrp: this.props.mrp, dnp: this.props.dnp,
    tax: this.props.tax,
  }

  componentDidMount() {
    this.update();
  }

  componentDidUpdate(props) {
    if (props.part_alias != this.props.part_alias) {
      this.update();
    }
  }

  update() {
    this.setState({ part_alias: this.props.part_alias })
  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  };

  add() {
    let context = this;
    let part_alias = this.state.part_alias;
    let mrp = this.state.mrp; let dnp = this.state.dnp;
    let tax= this.state.tax;
    tax = Number(tax);
    if (tax < 10) { tax = '1.0'+tax; }
    else { tax = '1.'+tax; }
    tax = Number(tax);
    if (part_alias == '' || part_alias == null || part_alias == undefined) {
      this.setState({ error: 'Enter the Alias name!!!' });
      return;
    }
    if (mrp == '' || mrp == null || mrp == undefined) {
      this.setState({ error: 'Enter the MRP!!!' });
      return;
    }
    if (dnp == '' || dnp == null || dnp == undefined) {
      this.setState({ error: 'Enter the DNP!!!' });
      return;
    }
    mrp = Number(mrp/tax);
    dnp = Number(dnp/tax);

    let data1 = { 'id': this.props.id, 'alias': part_alias, 'mrp': mrp, 'dnp': dnp,
                  'brand_id': this.props.brandId, 'partno': this.props.partno, 'tax': this.state.tax };
    context.setState({ load: true, message: 'ADD ALIAS!!!' })
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'spares/addaliasname.php',
      success: function(data) {
        context.setState({ load: false })
        if (data == 1) {
          context.props.getBrandById();
        }
        else {
          alert('Part Alias name is already exit');
        }
      },
      error: function(err) {
        context.setState({ load: false });
        alert('Try again!!!!')
      }
    });
  }

  render() {
    const { load, message } = this.state;
    return (
      <div>
        <Loading load={load} message={message} />
        <Grid>
          <Grid.Column mobile={16} tablet={16} computer={16}>
            <form noValidate autoComplete="off">
              <TextField id="outlined-name" label="Part Alias"
                value={this.state.part_alias}
                onChange={this.handleChange('part_alias')}
                margin="normal" fullWidth
                variant="outlined" />
            </form>
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={5}>
            <form noValidate autoComplete="off">
              <TextField id="outlined-name" label="TAX"
                disabled
                value={this.state.tax} onChange={this.handleChange('tax')}
                margin="normal" fullWidth variant="outlined" />
            </form>
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={5}>
            <form noValidate autoComplete="off">
              <TextField id="outlined-name" label="DNP"
                value={this.state.dnp} onChange={this.handleChange('dnp')}
                margin="normal" fullWidth variant="outlined" />
            </form>
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={6}>
            <form noValidate autoComplete="off">
              <TextField id="outlined-name" label="MRP"
                value={this.state.mrp} onChange={this.handleChange('mrp')}
                margin="normal" fullWidth variant="outlined" />
            </form>
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={16}>
            <center><div style={{color: 'red'}}>{this.state.error}</div></center>
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={8}>
            <Button fluid onClick={ () => { this.props.handleClose(); }}>CANCEL</Button>
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={8}>
            {load ?
              (<div><center><CircularProgress size={18} color='secoundary' /></center></div>)
             :
              (<div><Button fluid onClick={this.add.bind(this)}>SUBMIT</Button></div>)}
          </Grid.Column>
        </Grid>
      </div>
    );
  }
}

export default AddPartAlias;
